import { createSlice } from "@reduxjs/toolkit"
import { REGISTER } from "../../utils/constants"

const userData = localStorage.getItem("userData")

const initialState = {
  activeTab: REGISTER,
  userData: userData
    ? JSON.parse(userData)
    : {
        isUserLoggedIn: false,
      },
}

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state.userData = action.payload
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload
    },
  },
})

export const { setUserData, setActiveTab } = appSlice.actions

export default appSlice.reducer
